export default {"src":"/_next/static/media/icon-arrow-back-dark.12b2ef08.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};